import React from "react";
import "./SecSection.css";
import { useAppData } from "../contexts/AppDataContext";

const BASE = process.env.PUBLIC_URL || "/landing-page"; // e.g. "/landing" in dev

function SecSection() {
  const { appData, loading } = useAppData();

  const handleDownloadClick = () => {
    const downloadLink = appData?.iosAppLink || appData?.androidAppLink;
    if (downloadLink) {
      window.open(downloadLink, "_blank", "noopener,noreferrer");
    }
  };

  const hasStoreLink = !!(appData?.iosAppLink || appData?.androidAppLink);

  return (
    <section className="sec-wrapper" dir="ltr" aria-labelledby="sec-title">
      <div className="sec-container">
        {/* Banner */}
        <div className="sec-image" aria-hidden="true">
          <img
            src={`${BASE}/assets/pic1.png`}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Right side */}
        <div className="sec-content" dir="rtl">
          <div className="sec-badge" role="note">تطبيق تحرر</div>

          <h2 className="sec-title" id="sec-title">
            لأنك تستحق <span>حياة مختلفة</span>
          </h2>

          <p className="sec-text">
            القيمة تبدأ من داخلك، مو من الضغوط اللي حولك.
            <br />
            وسط العلاقات المرهقة والفراغ الداخلي، يجي وقت تسمع لنفسك بصدق.
          </p>

          <ul className="sec-list" aria-label="مزايا التطبيق">
            <li>
              <span className="li-ico">
                <img className="icons" src={`${BASE}/assets/sunIcon.png`} alt="" loading="lazy" />
              </span>
              أحب نفسك كما أنت.
            </li>
            <li>
              <span className="li-ico">
                <img className="icons" src={`${BASE}/assets/settingsIcon.png`} alt="" loading="lazy" />
              </span>
              سامح ذاتك وخفف حملك.
            </li>
            <li>
              <span className="li-ico">
                <img className="icons" src={`${BASE}/assets/heartIcon.png`} alt="" loading="lazy" />
              </span>
              اختر محيط يشبهك ويدعمك.
            </li>
            <li>
              <span className="li-ico">
                <img className="icons" src={`${BASE}/assets/scaleIcon.png`} alt="" loading="lazy" />
              </span>
              وازن بين تواصلك مع ذاتك ومع يومك.
            </li>
          </ul>

          <button
            type="button"
            className={`sec-cta ${(!hasStoreLink && !loading) ? "sec-cta--disabled" : ""}`}
            onClick={handleDownloadClick}
            disabled={!hasStoreLink || loading}
            aria-label="حمّل التطبيق الآن وابدأ رحلتك"
          >
            {loading ? "جارٍ التحميل..." : "حمّل التطبيق الآن وابدأ رحلتك ✨"}
          </button>
        </div>
      </div>
    </section>
  );
}

export default SecSection;
